// extracted by mini-css-extract-plugin
export default {"button":"SettingsButton_button__nvLv6"};